import React from 'react';

import ConfirmModal from '~/components/General/ConfirmModal';
import Mode from '~/components/Mode';

import { ImportConfirmModalCIcon } from '~/assets/images';

const CreateTestOrderConfirmModal = ({ open, onClose, onConfirm }) => (
  <ConfirmModal
    openConfirmModal={{
      open,
      header: 'Create New Test Order',
      message:
        'This order is being placed in Test Mode and will not mail. To place an order in Live Mode, switch to Live Mode.',
      successButtonName: 'Continue Anyway',
      cancelButtonName: 'Cancel',
      icon: ImportConfirmModalCIcon,
      className: 'testOrderConfirmModal',
      handleOk: onConfirm,
      handleClose: onClose,
      bodyContent: <Mode tooltipPlacement="above" />,
    }}
  />
);

export default CreateTestOrderConfirmModal;
